function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { actions as ppcActions } from '../../reducers/ppc.reducer';
import useHasPermission from '../../helpers/hooks/useHasPermission';
import PageBackButton from '../common/page/PageBackButton.react';
import ContactPersonAvailableAt from './ContactPersonAvailableAt.react';
import ContactPersonImage from './ContactPersonImage.react';
import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';
import CardBody from '../common/card/CardBody.react';
import Label from '../common/form/Label.react';
import Input from '../common/form/Input.react';
import Checkbox from '../common/form/Checkbox.react';
import Button from '../common/Button.react';
var FaqMain = function FaqMain() {
  var _useParams = useParams(),
    app = _useParams.app,
    contactID = _useParams.contactID;
  var hasPermission = useHasPermission("edit-".concat(app, "-contacts"));
  var dispatch = useDispatch();
  var contacts = useSelector(function (s) {
    return s.ppc.contacts || {};
  });
  useEffect(function () {
    dispatch({
      type: ppcActions.contactPersons,
      payload: {
        formData: {
          contactID: contactID
        }
      }
    });
  }, []);
  useEffect(function () {
    if (contacts[contactID]) setState(_objectSpread({}, contacts[contactID]));
  }, [contacts]);
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var name = state.name,
    position = state.position,
    phone = state.phone,
    email = state.email,
    archived = state.archived,
    submitProjectPopup = state.submitProjectPopup;
  var isValid = function isValid() {
    return (name === null || name === void 0 ? void 0 : name.length) > 0;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, app && /*#__PURE__*/React.createElement(PageBackButton, null), /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: name
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Label, {
    label: "Question",
    required: true
  }), /*#__PURE__*/React.createElement(Input, {
    value: name,
    onChange: function onChange(e) {
      return setState(_objectSpread(_objectSpread({}, state), {}, {
        name: e.target.value
      }));
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Position",
    required: true
  }), /*#__PURE__*/React.createElement(Input, {
    value: position,
    onChange: function onChange(e) {
      return setState(_objectSpread(_objectSpread({}, state), {}, {
        position: e.target.value
      }));
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Phone",
    required: true
  }), /*#__PURE__*/React.createElement(Input, {
    value: phone,
    onChange: function onChange(e) {
      return setState(_objectSpread(_objectSpread({}, state), {}, {
        phone: e.target.value
      }));
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Email",
    required: true
  }), /*#__PURE__*/React.createElement(Input, {
    value: email,
    onChange: function onChange(e) {
      return setState(_objectSpread(_objectSpread({}, state), {}, {
        email: e.target.value
      }));
    }
  }), !archived && hasPermission && /*#__PURE__*/React.createElement("div", {
    className: "a__btns"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Save",
    disabled: !isValid(),
    apiID: "update-contact-persons",
    onClick: function onClick() {
      dispatch({
        type: ppcActions.contactPersons,
        payload: {
          formData: {
            contactID: contactID,
            name: name,
            position: position,
            email: email,
            phone: phone,
            apiID: 'update-contact-persons'
          },
          method: 'put'
        }
      });
    }
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Submit Project Popup"
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Checkbox, {
    checked: submitProjectPopup === null || submitProjectPopup === void 0 ? void 0 : submitProjectPopup.isVisible,
    label: "Show in Submit Project Popup window",
    onChange: function onChange(isVisible) {
      setState(_objectSpread(_objectSpread({}, state), {}, {
        submitProjectPopup: {
          isVisible: isVisible
        }
      }));
      dispatch({
        type: ppcActions.contactPersons,
        payload: {
          formData: {
            contactID: contactID,
            isVisible: isVisible,
            apiID: 'submit-project-popup'
          },
          route: 'submit-project-popup',
          method: 'put'
        }
      });
    },
    disabled: archived || !hasPermission,
    apiID: "submit-project-popup",
    style: {
      maxWidth: 'none'
    }
  })))), /*#__PURE__*/React.createElement(ContactPersonImage, state));
};
export default FaqMain;